<template>
  <div>
    <h1 class="mb-4 font-bold text-3xl">
      Universitas
    </h1>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <search-filter
        v-model="form.search"
        class="w-full max-w-md mr-4"
        @reset="reset">
        <label class="block text-gray-700">Kota Studi:</label>
        <select
          v-model="form.kota_studi"
          class="mt-1 w-full form-select">
          <option :value="null">
            [ SEMUA KOTA ]
          </option>
          <option
            v-for="kota_studi in kotaStudis"
            :key="kota_studi.id"
            :value="kota_studi.id">
            {{ kota_studi.name }}
          </option>
        </select>
      </search-filter>
      <inertia-link
        class="btn-indigo"
        :href="route('universitas.create')">
        <span>Create</span>
        <span class="hidden md:inline">Universitas</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">
            Nama Kampus/Universitas
          </th>
          <th class="px-6 pt-6 pb-4">
            Kota Studi
          </th>
          <th class="px-6 pt-6 pb-4">
            Alamat
          </th>
          <th class="px-6 pt-6 pb-4">
            No.Telp
          </th>
          <th class="px-6 pt-6 pb-4" colspan="2">
            Last Update
          </th>
        </tr>
        <tr
          v-for="univ in universitas.data"
          :key="univ.id"
          class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t whitespace-normal">
            <inertia-link
              class="px-6 py-4 flex items-center focus:text-indigo-500"
              :href="route('universitas.edit', univ.id)">
              {{ univ.name }}
              <icon
                v-if="univ.deleted_at"
                name="trash"
                class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('universitas.edit', univ.id)"
              tabindex="-1">
              <div v-if="univ.kota_studi">
                {{ univ.kota_studi.name }}
              </div>
            </inertia-link>
          </td>
          <td class="border-t whitespace-normal">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('universitas.edit', univ.id)"
              tabindex="-1">
              {{ univ.address }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('universitas.edit', univ.id)"
              tabindex="-1">
              {{ univ.phone }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="px-6 py-4 flex items-center"
              :href="route('universitas.edit', univ.id)"
              tabindex="-1">
              {{ univ.updated_at }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link
              class="px-4 flex items-center"
              :href="route('universitas.edit', univ.id)"
              tabindex="-1">
              <icon
                name="cheveron-right"
                class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="universitas.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">
            No universitas found.
          </td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="universitas.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import { router, Link } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'Universitas' },
    components: {
        Icon,
        Pagination,
        SearchFilter,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        filters: Object,
        universitas: Object,
        kotaStudis: Array,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
                trashed: this.filters.trashed,
                kota_studi: this.filters.kota_studi,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                router.get('universitas', pickBy(this.form), {
                    preserveState: true,
                })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
